import { ITermoNotificacao } from "@/interfaces/ITermoNotificacao";
import { api } from "@/services/api";
import { PrinterOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import { useReactToPrint } from "react-to-print";
import { ImpressaoTermoNotificacao } from "../_components/ImpressaoTermoNotificacao";

export function VisualizacaoPrintTermoNotificacao() {
  const { codigoVerificador } = useParams<{ codigoVerificador: string }>();
  const termoNotificacaoRef = useRef<HTMLDivElement>(null);
  const [termo, setTermo] = useState<ITermoNotificacao>();

  useEffect(() => {
    document.title = "Inspeção Mobile - Impressão do Termo de Notificação";

    if (codigoVerificador) {
      api
        .get(`/termos-notificacao/publico/${codigoVerificador}/pdf`)
        .then((response) => {
          setTermo(response.data);
        })
        .catch((error) => {
          console.error("Erro ao buscar termo de notificação:", error);
        });
    }
  }, [codigoVerificador]);

  const handlePrint = useReactToPrint({
    contentRef: termoNotificacaoRef,
    documentTitle: `Termo de Notificação ${termo?.numero}`,
    suppressErrors: true,
    preserveAfterPrint: true,
  });

  return (
    <>
      <Result
        title={`Impressão do Termo de Notificação ${termo?.numero || ""}`}
        icon={<PrinterOutlined />}
        extra={
          <Button type="primary" onClick={handlePrint} disabled={!termo}>
            Imprimir
          </Button>
        }
      />
      <div style={{ display: "none" }}>
        <ImpressaoTermoNotificacao
          ref={termoNotificacaoRef}
          item={termo || null}
          marcadagua=""
        />
      </div>
    </>
  );
}
